import config from "@/config";
import { useDialog } from "@/Composables";
import { ModalTransition, PrintDialog } from "@/Components";

export default function usePrintDialog() {
    const { forceClose, toggleDialog } = useDialog();

    const togglePrintDialog = (event, data) => {
        toggleDialog(
            PrintDialog,
            ModalTransition,
            data,
            event,
            config.dialogs.drawers.zindex,
            true
        );
    };

    return {
        forceClose,
        togglePrintDialog,
    };
}
